import { ReactNode } from 'react'

import useSuspenseGetQueryInfo from '@/libs/apis/queries/use-suspense-get-query-info'

const QueryInfo = ({ username, children }: { username: string; children: ReactNode }) => {
  useSuspenseGetQueryInfo(username)

  return username && children
}

export default QueryInfo
